import React, { Fragment } from 'react'
import EditBtn from '../../buttons/EditBtn'
import DeleteBtn from '../../buttons/DeleteBtn'
import NullMssg from '../../common/NullMssg'
import { NoInfo } from '../../common/NoInfo'
import _ from 'lodash'

const UsersList = ({ allUsers, handleRemove, toEditUser }) => {
  //Ordenar un Array de Objetos
  allUsers = _.orderBy(allUsers, ['nombre'], ['asc'])
  return (
    <Fragment>
      <div className='table-wrapper'>
        <table>
          <thead>
            <tr>
              <th style={{ width: '260px', minWidth: '260px' }}>
                Nombre
              </th>
              <th style={{ width: '260px', minWidth: '260px' }}>
                Mail
              </th>
              <th style={{ width: '140px', minWidth: '140px' }}>
                Teléfono
              </th>
              <th>
                Rol
              </th>
              <th style={{ textAlign: 'right' }}>
                U.Negocio
              </th>
              <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {allUsers.length > 0 ? (
              allUsers.map((user) => (
                <tr key={user.id_Usuario}>
                  <td className="table-td-header">
                    {user.nombre}
                  </td>
                  <td>
                    {user.email}
                  </td>
                  <td>
                      {user.telefono ? user.telefono : NoInfo('Sin Teléfono')}
                  </td>
                  <td>
                      {user.roles != null ? user.roles.nombre : ' '}
                  </td>
                  <td style={{ textAlign: 'right', fontSize: '80%' }}>
                      {user?.negocioUnidadesObj &&
                      user?.negocioUnidadesObj.length > 0
                        ? user.negocioUnidadesObj.map((un, index) => (
                            <span key={index} style={{ display: 'block' }}>
                              {un.nombre}
                            </span>
                          ))
                        : user?.negocioUnidades &&
                          user?.negocioUnidades.length > 0
                        ? user.negocioUnidades.map((un, index) => (
                            <span key={index} style={{ display: 'block' }}>
                              {un}
                            </span>
                          ))
                        : NoInfo('Sin U.Negocio')}
                  </td>
                  <td className="table-td-actions">
                    <button onClick={() => toEditUser(user.id_Usuario)}>
                      <EditBtn />
                    </button>
                    <button onClick={() => handleRemove(user.id_Usuario)}>
                      <DeleteBtn />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <NullMssg />
            )}
          </tbody>
        </table>
      </div>
    </Fragment>
  )
}

export default UsersList
